import angular from 'angular';

/**
 * Creates a new RenderService.
 * Service which provide API to render files from html to other formats.
 * @param {object} Restangular - Service to send requests to server.
 * @param {object} DocumentService - Service to get .
 * @class RenderService.
 */
export function RenderService(Restangular, DocumentService) {
    /**
     * Use backend API for render pdf from html.
     * @param {string} htmlElement - Html content
     */
    const renderToPdf = ({ htmlElement, url, ...options }) => {
        if (htmlElement) {
            const preparedHtml = prepareForRender(htmlElement, options);

            return Restangular.all('render').all('pdf').withHttpConfig({ responseType: 'blob' }).post({ html: preparedHtml });
        }

        if (url) {
            return Restangular.all('render').all('pdf').withHttpConfig({ responseType: 'blob' }).post({ url });
        }
    };

    const prepareForRender = (htmlElement, options) => {
        return DocumentService.getProcessedHtml(htmlElement, options);
    };

    return {
        renderToPdf,
    };
}

angular.module('TALENYA-FE').factory('RenderService', RenderService);
